import { Box, Grid, Stack, Typography, useMediaQuery } from '@mui/material'
import { ThirdPartyConnectionsCard } from '../../../presentation-components/settings-components/third-party-connections-card'
import xero from "../../../../assets/images/xero.png"
import quickbook from "../../../../assets/images/quickbook.png";
import sage from "../../../../assets/images/sage.png";
import oracleNetsuite from "../../../../assets/images/oracle-netsuite.png"
import businessCentral from "../../../../assets/images/businesscentral.svg"
import gaiaTheme from '../../../../root-components/theme';
import { useContext } from 'react';
import { UserDetailsContext } from '../../../../context/user-details/user-details';
import { SettingsMobileNavbar } from '../../../../root-components/navigation/settings-mobile-navbar';
import { PageHeading } from '../../../presentation-components/display-elements-components/page-heading';
import { PageOuterContainer } from '../../../../root-components/layouts/page-outer-container';
import { CloudProviderLogo } from '../../../../modules/third-party-connection/cloud-components/cloud-provider-logo';

export const ThirdPartyConnectionsPage = () => {
  //Context
  const userDetailsContext = useContext(UserDetailsContext)
  const userDetails = userDetailsContext.userDetails
  //Layout
  const isMobileModeSm = useMediaQuery(gaiaTheme.breakpoints.down('sm'));
  //Variables
  const companyName = (!userDetails?.isPartner && userDetails?.partnerOrganisation) || (userDetails?.isPartner && userDetails?.isLoggedInAsClient) ? userDetails?.partnerOrganisation?.partnerName : 'Gaia';

  return (
    <PageOuterContainer>
      {isMobileModeSm && <Box sx={{ pb: 4 }}>
        <SettingsMobileNavbar />
      </Box>}
      <PageHeading
        title='Integrations'
        hasTabs={false}
      />
      <Stack sx={{ mb: 6 }}>
        <>
          <Typography variant='h6' sx={{ color: 'text.primary', pb: 2 }}>Financial</Typography>
          <Grid container spacing={4}>
            <Grid item xl={4} lg={4} md={6} xs={12} sm={12}>
              <ThirdPartyConnectionsCard title={'Xero'} image={xero} description={`Connect your ${companyName} account to Xero to streamline carbon accounting by calculating your carbon emissions based on your spending activities.`} link={'/settings/integrations/xero'} />
            </Grid>
            <Grid item xl={4} lg={4} md={6} xs={12} sm={12}>
              <ThirdPartyConnectionsCard title={'QuickBooks'} image={quickbook} description={`Connect your ${companyName} account to QuickBooks to streamline carbon accounting by calculating your carbon emissions based on your spending activities.`} link={'/settings/integrations/quickbooks'} />
            </Grid>
            <Grid item xl={4} lg={4} md={6} xs={12} sm={12}>
              <ThirdPartyConnectionsCard title={'Sage Accounting'} image={sage} description={`Connect your ${companyName} account to Sage Business Cloud Accounting to streamline carbon accounting by calculating your carbon emissions based on your spending activities.`} link={'/settings/integrations/sage'} />
            </Grid>
            {/* Two Sage tiles, so each says who it is for. A client on Sage 50 will otherwise
                click one of them, and a Sage 200 client needs to know Professional is not
                this: most of the installed base is Professional, and it is on-premise. */}
            <Grid item xl={4} lg={4} md={6} xs={12} sm={12}>
              <ThirdPartyConnectionsCard title={'Sage 200 Standard'} image={sage} description={`Connect your ${companyName} account to Sage 200 Standard to calculate emissions from your posted purchase ledger. Sage 50 and Sage 200 Professional are not supported.`} link={'/settings/integrations/sage200'} />
            </Grid>
            {/* Shown to everyone, like the cloud tiles: the details page says when the
                connector is not configured on this environment yet. */}
            <Grid item xl={4} lg={4} md={6} xs={12} sm={12}>
              <ThirdPartyConnectionsCard title={'Dynamics 365 Business Central'} image={businessCentral} imageWidth={150} description={`Connect your ${companyName} account to Microsoft Dynamics 365 Business Central to pull purchase invoices into your spend-based emissions automatically.`} link={'/settings/integrations/businesscentral'} />
            </Grid>
            <Grid item xl={4} lg={4} md={6} xs={12} sm={12}>
              <ThirdPartyConnectionsCard title={'NetSuite'} image={oracleNetsuite} description={`Connect your ${companyName} account to NetSuite to streamline carbon accounting by calculating your carbon emissions based on your spending activities.`} link={'/settings/integrations/netsuite'} comingSoon />
            </Grid>
          </Grid>
        </>
      </Stack>
      <Stack sx={{ mb: 6 }}>
        {/* Supplier-reported figures from the cloud vendors themselves. The copy names no
            platform brand: these tiles are seen by partner clients too. */}
        <Typography variant='h6' sx={{ color: 'text.primary', pb: 2 }}>Cloud providers</Typography>
        <Grid container spacing={4}>
          <Grid item xl={4} lg={4} md={6} xs={12} sm={12}>
            <ThirdPartyConnectionsCard
              title={'AWS Sustainability'}
              icon={<CloudProviderLogo provider='aws-sustainability' />}
              description={'Bring in the carbon figures AWS calculates for each of your accounts every month. They replace the spend estimate on your AWS invoices, so nothing is counted twice.'}
              link={'/settings/integrations/aws-sustainability'} />
          </Grid>
          <Grid item xl={4} lg={4} md={6} xs={12} sm={12}>
            <ThirdPartyConnectionsCard
              title={'Carbon optimization in Azure'}
              icon={<CloudProviderLogo provider='azure-carbon' />}
              description={'Bring in the carbon figures Microsoft calculates for each of your Azure subscriptions every month. They replace the spend estimate on your Azure invoices, so nothing is counted twice.'}
              link={'/settings/integrations/azure-carbon'} />
          </Grid>
          <Grid item xl={4} lg={4} md={6} xs={12} sm={12}>
            <ThirdPartyConnectionsCard
              title={'Google Cloud Carbon Footprint'}
              icon={<CloudProviderLogo provider='google-cloud-carbon' />}
              description={'Bring in the carbon figures Google calculates for each of your Google Cloud projects every month. They replace the spend estimate on your Google Cloud invoices, so nothing is counted twice.'}
              link={'/settings/integrations/google-cloud-carbon'} />
          </Grid>
        </Grid>
      </Stack>
    </PageOuterContainer>
  )
}